const domElements = {};
const API_STREETS_URL = '/?type=157203835';

function initDomElements() {
  domElements.main = $('.order__step--4');
  if (domElements.main.length < 1) return false;
  domElements.form = domElements.main.find('form.order-step__form');
  domElements.sendButton = domElements.main.find('.form__action__next-button');
  domElements.homeAddressCheckbox = domElements.main.find(
      '.checkbox-home-address');
  domElements.homeAddressFieldset = domElements.main.find(
      '.form__fieldset--home-address');
  domElements.emailInput = domElements.main.find('.email-input');
  domElements.emailRepeatInput = domElements.main.find('.email-repeat-input');
  domElements.homeStreetInput = domElements.main.find('#homeStreet');
  domElements.homeStreetSelect = domElements.main.find('#homeStreet2');
  domElements.homeAddressTypeRadio1 = domElements.main.find(
      '#homeAddressType1');
  domElements.homeAddressTypeRadio2 = domElements.main.find(
      '#homeAddressType2');
  domElements.homeCityInput = domElements.main.find('#homeCity');
  domElements.homeZipcodeInput = domElements.main.find('#homeZipcode');
  return true;
}

function showFieldset() {
  domElements.homeAddressFieldset.show();
  domElements.homeAddressFieldset.find('input').attr('required', true);
}

function hideFieldset() {
  domElements.homeAddressFieldset.hide();
  domElements.homeAddressFieldset.find('input').attr('required', false);
}

function initValidateRepeatEmail() {
  domElements.emailInput.on('change', validateRepeatEmail);
  domElements.emailRepeatInput.on('keyup', validateRepeatEmail);
}

function validateRepeatEmail() {
  if (domElements.emailInput.val() !== domElements.emailRepeatInput.val()) {
    domElements.emailRepeatInput[0].setCustomValidity(
        'E-Mail-Adresse stimmt nicht überein');
  } else {
    domElements.emailRepeatInput[0].setCustomValidity('');
  }
}

function initDisablePasteEmails() {
  domElements.emailInput.on('paste', event => {
    event.preventDefault();
  });
  domElements.emailRepeatInput.on('paste', event => {
    event.preventDefault();
  });
}

function initHomeStreetSelect() {
  // domElements.homeStreetSelect.on('change', event => {
  //   console.log('val', domElements.homeStreetSelect.val());
  //   domElements.homeStreetInput.val(domElements.homeStreetSelect.val());
  // });

  domElements.homeStreetSelect.on('select2:select', event => {
    domElements.homeStreetInput.val(event.params.data.id);
    domElements.homeZipcodeInput.val(event.params.data.zipcode);
  });
}

function initHomeAddressTypeSwitch() {
  if (domElements.homeAddressTypeRadio1.is(':checked')) {
    updateHomeAddressByType(1, true);
  } else {
    updateHomeAddressByType(2, true);
  }

  domElements.homeAddressTypeRadio1.on('change', event => {
    if (domElements.homeAddressTypeRadio1.is(':checked')) {
      updateHomeAddressByType(1);
    }
  });
  domElements.homeAddressTypeRadio2.on('change', event => {
    if (domElements.homeAddressTypeRadio2.is(':checked')) {
      updateHomeAddressByType(2);
    }
  });
}

/**
 *
 * @param type
 * type = 1 = duisburg
 * type = 2 = other city
 */
function updateHomeAddressByType(type, initial) {
  console.log('updateHomeAddressByType', type);

  switch (type) {
    case 1:
      domElements.homeStreetInput.hide();
      domElements.homeStreetSelect.show();
      domElements.homeStreetSelect.select2({
        placeholder: 'Straße',
        minimumInputLength: 3,
        ajax: {
          url: API_STREETS_URL,
          delay: 100,
          data: function(params) {
            return {
              phrase: params.term,
              mode: 'namesOnly'
            };
          }
        }
      });

      if (initial === true) {
        domElements.homeStreetSelect.append($("<option selected='selected'></option>").val(domElements.homeStreetInput.val()).text( domElements.homeStreetInput.val())).trigger('change');
      }

      domElements.homeCityInput.val('Duisburg');
      domElements.homeCityInput.attr('readonly', true);
      domElements.homeZipcodeInput.attr('readonly', true);
      break;

    case 2:
      domElements.homeStreetInput.show();
      domElements.homeStreetSelect.hide();
      try {
        domElements.homeStreetSelect.select2('destroy');
      } catch(e) {

      }
      if (domElements.homeCityInput.val() === 'Duisburg') {
        domElements.homeCityInput.val('');
      }
      domElements.homeCityInput.attr('readonly', false);
      domElements.homeZipcodeInput.attr('readonly', false);
      break;
  }
}

function step4() {
  if (!initDomElements()) {
    return false;
  }

  /** prevent double submit: */
  domElements.form.on('submit', event => {
    domElements.sendButton.attr('disabled', true);
  });

  domElements.homeAddressCheckbox.on('change', event => {
    if (domElements.homeAddressCheckbox.is(':checked')) {
      showFieldset();
    } else {
      hideFieldset();
    }
  });

  if (domElements.homeAddressCheckbox.is(':checked')) {
    showFieldset();
  } else {
    hideFieldset();
  }

  initValidateRepeatEmail();
  initDisablePasteEmails();

  initHomeAddressTypeSwitch();

  initHomeStreetSelect();
}

export default step4;